/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
import { encodeJSON, encodeSimple } from "../lib/encodings.js";
import { EventStream } from "../lib/event-streams.js";
import * as M from "../lib/matchers.js";
import { compactMap } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { pathToFunc } from "../lib/url.js";
import * as components from "../models/components/index.js";
import * as errors from "../models/errors/index.js";
import * as operations from "../models/operations/index.js";
import { APIPromise } from "../types/async.js";
/**
 * Append a message to a conversation and generate a new response.
 */
export function conversationsAppendConversationMessage(client, request, options) {
    return new APIPromise($do(client, request, options));
}
async function $do(client, request, options) {
    const parsed = safeParse(request, (value) => operations.AppendConversationMessageRequest$outboundSchema.parse(value), "Input validation failed");
    if (!parsed.ok) {
        return [parsed, { status: "invalid" }];
    }
    const payload = parsed.value;
    const body = encodeJSON("body", payload.AppendConversationMessageRequest, {
        explode: true,
    });
    const pathParams = {
        conversationId: encodeSimple("conversationId", payload.conversationId, {
            explode: false,
            charEncoding: "percent",
        }),
    };
    const path = pathToFunc("/conversations/{conversationId}/messages")(pathParams);
    const headers = new Headers(compactMap({
        "Content-Type": "application/json",
        Accept: "text/event-stream",
        "X-Org-Id": encodeSimple("X-Org-Id", payload["X-Org-Id"], {
            explode: false,
            charEncoding: "none",
        }),
    }));
    const context = {
        baseURL: options?.serverURL ?? client._baseURL ?? "",
        operationID: "appendConversationMessage",
        oAuth2Scopes: [],
        resolvedSecurity: null,
        securitySource: null,
        retryConfig: options?.retries
            || client._options.retryConfig
            || { strategy: "none" },
        retryCodes: options?.retryCodes || ["429", "500", "502", "503", "504"],
    };
    const requestRes = client._createRequest(context, {
        method: "POST",
        baseURL: options?.serverURL,
        path: path,
        headers: headers,
        body: body,
        timeoutMs: options?.timeoutMs || client._options.timeoutMs || -1,
    }, options);
    if (!requestRes.ok) {
        return [requestRes, { status: "invalid" }];
    }
    const req = requestRes.value;
    const doResult = await client._do(req, {
        context,
        errorCodes: ["400", "401", "403", "404", "4XX", "5XX"],
        retryConfig: context.retryConfig,
        retryCodes: context.retryCodes,
    });
    if (!doResult.ok) {
        return [doResult, { status: "request-error", request: req }];
    }
    const response = doResult.value;
    const responseFields = {
        HttpMeta: { Response: response, Request: req },
    };
    const [result] = await M.match(M.sse(200, z.instanceof((ReadableStream)).transform(stream => {
        return new EventStream({
            stream,
            decoder(rawEvent) {
                const schema = components.StreamingConversationMessage$inboundSchema;
                return schema.parse(rawEvent);
            },
        });
    })), M.jsonErr([400, 401, 403, 404], errors.ProblemDetails$inboundSchema), M.fail("4XX"), M.fail("5XX"))(response, { extraFields: responseFields });
    if (!result.ok) {
        return [result, { status: "complete", request: req, response }];
    }
    return [result, { status: "complete", request: req, response }];
}
//# sourceMappingURL=conversationsAppendConversationMessage.js.map